import { z } from "zod";

export const FornecedorSimplificadoSchema = z.object({
    nomeFantasia: z.string().nonempty("Nome do fornecedor é obrigatório."),

    ativo: z.boolean().default(true),
    avaliar: z.boolean().default(true),
    fornProduto: z.boolean().default(true),
    fornServico: z.boolean().default(true),

    idCentroCusto: z.coerce.number().optional().nullable().default(null),
    cpf: z.coerce.string().nullable().default(null),
    cnpj: z.coerce.string().nullable().default(null),
    familia: z.coerce.string().nullable().default(null),
    observacao: z.coerce.string().nullable().default(null),
    outro: z.boolean().default(true),

});

export type FornecedorSimplificadoForm = z.infer<typeof FornecedorSimplificadoSchema>;

export const defaultFornecedorSimplificadoForm: Partial<FornecedorSimplificadoForm> = {
    ativo: true,
    avaliar: true,
    fornProduto: true,
    fornServico: false,
    outro: true,

}